import { useQuery } from '@tanstack/react-query';
import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import fitdocApi from '../../lib/axios';
import { AlertDialog, AlertDialogContent, AlertDialogTitle } from '../ui/alert-dialog';
import * as Icon from 'lucide-react'

const DocumentViewer = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [open, setOpen] = React.useState(false);

    useEffect(()=>{
        const docid = searchParams.get('docid');
        if(docid) {
            setOpen(true);
        }
    }, [searchParams])

    function handleClose () {
        searchParams.delete('docid');
        setSearchParams(searchParams);
        setOpen(false);
    }

    function handleChangeOpen (open:boolean) {
        if(!open) {
            handleClose()
        }
    }

    const { data, isLoading } = useQuery({
        queryKey: [`document-${searchParams.get('docid')}`],
        queryFn: async () => {
            const { data } = await fitdocApi.get('documents/get', {
                params: {
                    docid: searchParams.get('docid')
                }
            })
            if(data.errorcode!==0)  throw new Error('Error fetching document');
            if(!data.object) throw new Error('Error fetching document');

            return data.object;
        },
        enabled: !!searchParams.get('docid')
    })


  return (
    <AlertDialog open={open} onOpenChange={(open) => handleChangeOpen(open)}>
        <AlertDialogContent className="max-h-[95dvh] max-w-[95dvw] overflow-auto w-full h-full">
            <div className='flex flex-col justify-between gap-4'>
                <div className='flex items-center justify-between'>
                    <AlertDialogTitle>{data?.filename}</AlertDialogTitle>
                    <button onClick={()=>{handleClose()}}>
                        <Icon.X className='w-4 h-4'/>
                    </button>
                </div>
                <div className='w-full h-full overflow-auto'>
                    {(!data && isLoading) &&
                    <div className='flex items-center justify-center'><Icon.Loader2 className='w-4 h-4 animate-spin'/></div>
                    }

                    {data && 
                    <iframe
                        src={`data:application/pdf;base64,${data?.file}`}
                        className="w-full h-full"
                    />
                    }
                </div>
            </div>
        </AlertDialogContent>
    </AlertDialog>
  )
}

export default DocumentViewer